"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortRolesByAlias = exports.transformRoleName = void 0;
var b2b_roles_1 = require("../types/b2b-roles");
var transformRoleName = function (roleName) {
    return roleName.replace(/_/g, ' ').replace(/\w\S*/g, function (role) {
        return role.charAt(0).toUpperCase() + role.substr(1).toLowerCase();
    });
};
exports.transformRoleName = transformRoleName;
var sortRolesByAlias = function (roles) {
    return roles.sort(function (firstRole, secondRole) {
        return b2b_roles_1.RoleDefinitions[firstRole].alias.localeCompare(b2b_roles_1.RoleDefinitions[secondRole].alias);
    });
};
exports.sortRolesByAlias = sortRolesByAlias;
